import React, { createContext, PureComponent, useContext } from 'react';
import WebAudio from 'app/services/WebAudio';

const WebAudioContext = createContext<WebAudio | undefined>(undefined);

export const useWebAudio = () => useContext(WebAudioContext);

interface IProps {
  service?: WebAudio;
  children: React.ReactNode;
}

/**
 * Provider of the WebAudio service.
 *
 * Optionally pass in an existing instance of the service. Otherwise,
 * a new one is created on construction.
 */
export class WebAudioProvider extends PureComponent<IProps> {
  private readonly service: WebAudio;
  private readonly ownsService: boolean;
  public constructor(props: IProps) {
    super(props);
    this.service = props.service || new WebAudio();
    this.ownsService = props.service === undefined;
  }

  public componentWillUnmount() {
    // If the provider created the service, we close the audio context on unmount
    if (this.ownsService) {
      this.service.closeAudioContext();
    }
  }

  public render() {
    return (
      <WebAudioContext.Provider value={this.service}>
        {this.props.children}
      </WebAudioContext.Provider>
    );
  }
}

export const WebAudioConsumer = WebAudioContext.Consumer;
